// Day-granularity countdowns, shared by the landing hero and the account dashboard.
//
// Everything here works in WHOLE DAYS against the viewer's own calendar, and floors both
// sides to midnight before subtracting. Comparing raw timestamps makes a countdown flip at
// whatever time of day the deadline happens to fall — 3pm, say — which is not what anyone
// counting down means.
//
// The server is the authority on whether something is still open (a closing date runs to
// 23:59:59 on the day itself); these functions only ever describe how long is left.

/** Midnight this morning, as a timestamp. */
export const startOfToday = () => {
  const n = new Date();
  return new Date(n.getFullYear(), n.getMonth(), n.getDate()).getTime();
};

/** Whole days from `from` to an ISO date, or null when there is no usable date. */
export function daysUntil(iso, from = startOfToday()) {
  const [y, m, d] = String(iso ?? '').slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return null;
  return Math.round((new Date(y, m - 1, d).getTime() - from) / 86400000);
}

/**
 * How long is left before a deadline — '' when there is no date, or when it has passed.
 *
 * A deadline is only ever counted DOWN: whatever the date belongs to is withdrawn by the
 * server once it is behind us, so a negative number here would mean the two disagree.
 */
export function deadlineIn(iso, from = startOfToday()) {
  const n = daysUntil(iso, from);
  if (n === null || n < 0) return '';
  if (n === 0) return 'closes today';
  if (n === 1) return 'closes tomorrow';
  return `${n} days left`;
}

/** Inside the last fortnight, a deadline should start to press. */
export function isUrgent(iso, from = startOfToday(), within = 14) {
  const n = daysUntil(iso, from);
  return n !== null && n >= 0 && n <= within;
}
